import React from 'react';
import styles from './SuccessModal.module.css';

const SuccessModal = ({ isOpen, onClose, onCheckout, message }) => {
  if (!isOpen) return null;

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div
        className={styles.successModalContent}
        onClick={(e) => e.stopPropagation()}
      >
        <h5 className={styles.successModalTitle}>{message || 'Successfully Added to Cart'}</h5>
        <div className={styles.successModalButtons}>
          <button
            type="button"
            className={styles.keepShoppingButton}
            onClick={onClose}
          >
            Keep Shopping
          </button>
          <button
            type="button"
            className={styles.checkoutButton}
            onClick={onCheckout}
          >
            <div className={styles.checkoutIcon}>
              <svg viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg">
                <circle cx="128" cy="128" r="96" fill="white" />
                <polyline points="104 160 136 128 104 96" fill="none" stroke="black" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24" />
                <polyline points="144 160 176 128 144 96" fill="none" stroke="black" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24" />
              </svg>
            </div>
            <span>Review Order</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;